import type { LabelHTMLAttributes } from 'preact';
import { cn } from '../../lib/utils';

/**
 * Libellé de champ.
 *
 * Toujours un vrai `<label for>`, jamais un texte d'espace réservé : un
 * `placeholder` disparaît à la saisie et n'est annoncé par aucun lecteur
 * d'écran.
 */
export function Label({ className, ...reste }: LabelHTMLAttributes) {
  return (
    <label
      data-slot="label"
      className={cn(
        'flex select-none items-center gap-2 text-sm font-medium leading-none',
        'group-data-[disabled=true]:pointer-events-none group-data-[disabled=true]:opacity-50',
        'peer-disabled:cursor-not-allowed peer-disabled:opacity-50',
        className,
      )}
      {...reste}
    />
  );
}
